<template>
    <main class="container_istc_mobile" id="ISTCMobile">
        <!--section top -->
        <section class="container_istc_mobile__section_top">
            <!-- article top -->
            <article class="container_istc_mobile__section_top__article_top">
                <aside class="container_istc_mobile__section_top__article_top__aside">
                    <div class="container_istc_mobile__section_top__article_top__aside__div">
                        <h1 class="container_istc_mobile__section_top__article_top__aside__div__h1">
                            Manipulations
                        </h1>
                    </div>
                </aside>
            </article>
            <!-- article bottom -->
            <article class="container_istc_mobile__section_top__article_bottom">
                <aside class="container_istc_mobile__section_top__article_bottom__aside">
                    <div class="container_istc_mobile__section_top__article_bottom__aside__div_top">
                        <img src="@/assets/rifle_tactical_reload.jpg" alt="Instruction au tir de combat"
                            class="container_istc_mobile__section_top__article_bottom__aside__div_top__img">
                    </div>
                    <!-- div bottom -->
                    <div class="container_istc_mobile__section_top__article_bottom__aside__div_bottom">
                        <p class="container_istc_mobile__section_top__article_bottom__aside__div_bottom__p">
                            Formation instruction au tir de combat.
                            Positions de tir fondamentaux etc.

                            Instruction au domaine tactique.
                        </p>
                    </div>
                </aside>
                <!-- aside bottom-->
            </article>
        </section>
        <!-- section bottom-->
        <section class="container_istc_mobile__section_bottom">
            <article class="container_istc_mobile__section_bottom__article_top">
                <aside class="container_istc_mobile__section_bottom__article_top__aside_top">
                    <div class="container_istc_mobile__section_bottom__article_top__aside_top__div_title">
                        <h1 class="container_istc_mobile__section_bottom__article_top__aside_top__div_title__h1">
                            Tarif
                        </h1>
                    </div>
                    <!-- div -->
                    <div class="container_istc_mobile__section_bottom__article_top__aside_top__div_text">
                        <p class="container_istc_mobile__section_bottom__article_top__aside_top__div_text__p">
                            - Instruction ISTC = 140 € / jour <br>
                        </p>
                        <p class="container_istc_mobile__section_bottom__article_top__aside_top__div_text__prix">
                            <!-- Prix total : 1 700 € -->
                        </p>
                    </div>
                </aside>
                <!-- aside bottom-->
                <aside class="container_istc_mobile__section_bottom__article_top__aside_bottom">
                    <div class="container_istc_mobile__section_bottom__article_top__aside_bottom__div_left">
                        <router-link
                            class="container_istc_mobile__section_bottom__article_top__aside_bottom__div_left__router-link"
                            to="/contact">
                            <p
                                class="container_istc_mobile__section_bottom__article_top__aside_bottom__div_left__router-link__p">
                                Choisir
                            </p>
                        </router-link>
                    </div>
                    <!-- button -->
                </aside>
            </article>
            <!-- article bottom-->
            <article class="container_istc_mobile__section_bottom__article_bottom">
                <aside class="container_istc_mobile__section_bottom__article_bottom__aside_left">
                    <router-link class="container_istc_mobile__section_bottom__article_bottom__aside_left__router-link"
                        to="/defense">
                        <button
                            class="container_istc_mobile__section_bottom__article_bottom__aside_left__router-link__button">
                            <div
                                class="container_applicationweb_mobile__section_bottom__article_bottom__aside_left__router-link__button__div_back"  id="div_button">
                                <img src="@/assets/back.png" alt="back"
                                    class="container_applicationweb_mobile__section_bottom__article_bottom__aside_left__router-link__button__div_back__img" id="button_arrow">
                            </div>
                        </button>
                    </router-link>
                </aside>
                <!-- aside right -->
                <aside class="container_istc_mobile__section_bottom__article_bottom__aside_right">
                    <router-link class="container_istc_mobile__section_bottom__article_bottom__aside_right__router-link"
                        to="/instruction">
                        <button
                            class="container_istc_mobile__section_bottom__article_bottom__aside_right__router-link__button">
                            <div
                                class="container_applicationweb_mobile__section_bottom__article_bottom__aside_right__router-link__button__div_next"  id="div_button">
                                <img src="@/assets/next.png" alt="next"
                                    class="container_applicationweb_mobile__section_bottom__article_bottom__aside_right__router-link__button__div_next__img" id="button_arrow">
                            </div>
                        </button>
                    </router-link>
                </aside>
            </article>
        </section>
    </main>
</template>

<script >
export default {
    name: 'IstcMobile',
}
</script>

<style  lang=scss>
//@import "@/style/components/Services/Istc/IstcMobile.scss";

@media screen and(min-width: 926px) {
    #ISTCMobile {
        display: none;
    }
}

@import "@/style/color.scss";
@import "@/style/effets.scss";

.container_istc_mobile {
    margin: auto;
    width: 100vw;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background-color: $BG;

    &__section_top {
        display: flex;
        flex-direction: column;
        margin-left: auto;
        margin-right: auto;

        &__article_top {
            margin-left: auto;
            margin-right: auto;

            &__aside {
                margin-right: auto;
                margin-left: auto;
                border: solid 0.25rem white;
                border-radius: 1rem;
                width: 16rem;
                height: 4rem;
                margin-top: 2vh;

                &__div {
                    margin-top: auto;
                    margin-bottom: auto;
                    text-align: center;

                    &__h1 {
                        font-size: $h1;
                        font-weight: normal;
                        margin: auto;
                        margin-top: 0.2rem;
                    }
                }
            }
        }

        // ###################
        // article bottom

        &__article_bottom {
            margin-right: auto;
            margin-left: auto;
            margin-top: 1rem;
            background-color: white;
            width: 100vw;
            overflow: hidden;
            padding-top: 1vh;
            padding-bottom: 1vh;

            &__aside {
                margin: auto;
                width: 96vw;

                &__div_top {
                    width: 80vw;
                    margin-left: auto;
                    margin-right: auto;

                    &__img {
                        width: 80vw;
                    }
                }

                //  div bottom

                &__div_bottom {
                    width: 80vw;
                    margin-left: auto;
                    margin-right: auto;
                    text-align: start;
                    height: 12vh;
                    padding-top: 4vh;

                    &__p {
                        font-weight: 400;
                        font-size: $service-text;
                    }
                }
            }
        }
    }

    //###################
    // section bottom

    &__section_bottom {
        margin: auto;
        display: flex;
        flex-direction: column;

        &__article_top {
            margin-left: auto;
            margin-right: auto;

            &__aside_top {
                margin-left: auto;
                margin-right: auto;
                display: flex;
                flex-direction: column;

                &__div_title {
                    margin-left: auto;
                    margin-right: auto;
                    text-align: center;

                    &__h1 {
                        font-size: $h1;
                    }
                }

                // div text

                &__div_text {
                    margin-left: auto;
                    margin-right: auto;

                    &__p {
                        font-size: $service-text;
                    }

                    &__prix {
                        font-size: $text;
                        padding-bottom: 1rem;
                    }
                }
            }

            // aside bottom

            &__aside_bottom {
                margin-left: auto;
                margin-right: auto;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding-bottom: 1rem;

                // div left

                &__div_left {
                    background-color: black;
                    width: 8rem;
                    height: 3rem;
                    border-radius: 3rem;

                    &__router-link {
                        margin-left: auto;
                        margin-right: auto;
                        text-align: center;

                        &__p {
                            font-size: $text;
                            font-weight: bolder;
                            color: white;
                            margin-top: 0.25rem;
                        }
                    }
                }
            }
        }

        // article bottom

        &__article_bottom {
            margin-left: auto;
            margin-right: auto;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            background-color: white;
            width: 100vw;
            height: 16rem;
            border-bottom: 3px $BG solid;

            &__aside_left {
                margin-top: auto;
                margin-bottom: auto;
                margin-left: 4vw;
                height: 8rem;
                width: 8rem;

                &__router-link {
                    margin: auto;

                    &__button {
                        height: 8rem;
                        width: 8rem;
                        margin: auto;
                        background-color: white;
                        border: none;
                        box-shadow: $ombres;
                        border-radius: 1rem;
                        display: flex;
                        flex-direction: column;

                        &__div_1 {
                            height: 0.25rem;
                            width: 4rem;
                            background-color: $BF;
                            rotate: -45deg;
                            margin: auto;
                            position: relative;
                            top: 0.7rem;
                        }

                        &__div_2 {
                            height: 0.25rem;
                            width: 4rem;
                            background-color: $BF;
                            rotate: 45deg;
                            margin: auto;
                            position: relative;
                            bottom: 0.68rem;
                        }
                    }
                }
            }

            //aside righ

            &__aside_right {
                margin-top: auto;
                margin-bottom: auto;
                height: 8rem;
                width: 8rem;
                margin-right: 4vw;

                &__router-link {
                    margin: auto;

                    &__button {
                        height: 8rem;
                        width: 8rem;
                        margin: auto;
                        background-color: white;
                        border: none;
                        box-shadow: $ombres;
                        border-radius: 1rem;
                        display: flex;
                        flex-direction: column;

                        &__div_1 {
                            height: 0.25rem;
                            width: 4rem;
                            background-color: $BF;
                            rotate: 45deg;
                            margin: auto;
                            position: relative;
                            top: 0.7rem;
                        }

                        &__div_2 {
                            height: 0.25rem;
                            width: 4rem;
                            background-color: $BF;
                            rotate: -45deg;
                            margin: auto;
                            position: relative;
                            bottom: 0.68rem;
                        }
                    }
                }
            }
        }
    }
}
</style>